<div class="avatar-initials-container">
    <div *ngIf="url" [style.background-image]="'url(' + url + ')'"></div>
    <div *ngIf="!url" [style.background-color]="color">{{iniciales}}</div>
</div>